var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.25 54.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m29.63,5.08c-6.78-6.78-17.77-6.78-24.54,0-6.78,6.78-6.78,17.77,0,24.54l24.54,24.54,24.54-24.54c6.78-6.78,6.78-17.77,0-24.54s-17.77-6.78-24.54,0Zm17.79,17.79l-6.75,6.75-11.04,11.04-11.04-11.04-6.75-6.75c-3.05-3.05-3.05-7.99,0-11.04s7.99-3.05,11.04,0l6.75,6.75,6.75-6.75c3.05-3.05,7.99-3.05,11.04,0,3.05,3.05,3.05,7.99,0,11.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco);
export default __webpack_public_path__ + "static/media/ico.65fb9860d5f33029be3f600fa634f44f.svg";
export { ForwardRef as ReactComponent };